import { bootstrapWidget } from "../../common";
import SpacesWidget from "./widget";

bootstrapWidget({ widget: SpacesWidget, widgetType: "spaces" });
